'use client';
import { useEffect, useState } from 'react';

export const COOKIE_AUTH_STATUS_KEY = 'cookieAuthStatus';

export enum ECookieAuthStatus {
  /** 拒绝 */
  'REJECT' = '0',
  /** 同意 */
  'ACCEPT' = '1',
}

export const useCookieAuthStatus = ({
  storageKey = COOKIE_AUTH_STATUS_KEY,
}: {
  storageKey?: string;
} = {}) => {
  // 是否开启cookie检查
  const isOpenCookieCheck = process.env.NEXT_PUBLIC_OPEN_COOKIE_CHECK === '1';

  const [cookieAuthStatus, setCookieAuthStatus] = useState<string | null>(
    localStorage.getItem(storageKey)
  );

  useEffect(() => {
    // 事件派发必须window.dispatchEvent，该事件才会生效
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === storageKey) {
        const newStatus = e.newValue;
        localStorage.setItem(storageKey, newStatus || '');
        setCookieAuthStatus(newStatus);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    // 组件卸载时清理
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  return { cookieAuthStatus, isOpenCookieCheck };
};
